"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _router = require("@reach/router");

var _antd = require("antd");

var _lodash = require("lodash");

var _immer = _interopRequireDefault(require("immer"));

var _Home = _interopRequireDefault(require("../pages/Home"));

var _Profile = _interopRequireDefault(require("../pages/Profile"));

var _PostEditor = _interopRequireDefault(require("../pages/PostEditor"));

var _Dashboard = _interopRequireDefault(require("../pages/Dashboard"));

var _Media = _interopRequireDefault(require("../pages/Media"));

var _PostType = _interopRequireDefault(require("../pages/PostType"));

var _GeneralSettings = _interopRequireDefault(require("../pages/GeneralSettings"));

var _Taxonomy = _interopRequireDefault(require("../pages/Taxonomy"));

var _Users = _interopRequireDefault(require("../pages/Users"));

var _Loader = _interopRequireDefault(require("./Loader"));

var _PrivateRoute = _interopRequireDefault(require("./PrivateRoute"));

var _theme = require("../theme");

var _store = require("../store");

var _actions = require("../actions");

var _auth = require("../utils/auth");

var _routes = require("../routes"); // import components


var Master = function Master(props) {
  var _authUser$capabilitie, _authUser$capabilitie2;

  var defaultComponent = props.defaultComponent;

  var _ref = (0, _store.useStore)(),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      config = _ref2$.config,
      authUser = _ref2$.authState.authUser,
      dialog = _ref2$.appState.dialog,
      _ref2$$cmsState = _ref2$.cmsState,
      sites = _ref2$$cmsState.sites,
      siteID = _ref2$$cmsState.siteID,
      siteHasChanged = _ref2$.editorState.siteHasChanged,
      dispatch = _ref2[1];

  var previewID = (0, _auth.isPreview)(); // timers for refresh token and site updates

  var _ref3 = (0, _react.useState)(0),
      _ref4 = _slicedToArray(_ref3, 2),
      refreshTimer = _ref4[0],
      setRefreshTimer = _ref4[1];

  var _ref5 = (0, _react.useState)(0),
      _ref6 = _slicedToArray(_ref5, 2),
      updatesTimer = _ref6[0],
      setUpdatesTimer = _ref6[1];

  (0, _react.useEffect)(function () {
    // activate timer for refresh token
    var refreshID = setInterval(function () {
      setRefreshTimer(function (time) {
        return time + 1;
      });
    }, 120000); // 2 minutes
    // activate timer for site updates

    var updatesID = setInterval(function () {
      setUpdatesTimer(function (time) {
        return time + 1;
      });
    }, 10000); // 10 seconds
    // Clear both timers

    return function () {
      clearInterval(refreshID);
      clearInterval(updatesID);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var loadUser = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _actions.userActions.getAuthUser({}, dispatch, config);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function loadUser() {
        return _ref7.apply(this, arguments);
      };
    }();

    loadUser();
  }, []);
  (0, _react.useEffect)(function () {
    var loadSite = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!previewID) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return _actions.previewActions.getSitePreview({
                  siteID: config.siteID,
                  previewID: previewID
                }, dispatch, config);

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.next = 7;
                return _actions.siteActions.getSite({
                  siteID: config.siteID
                }, dispatch, config);

              case 7:
                result = _context2.sent;

                if (result) {
                  dispatch({
                    type: 'ADD_SITE',
                    payload: result
                  });

                  if (!siteHasChanged) {
                    // Silently update site in editor if there are no changes
                    dispatch({
                      type: 'ADD_EDITOR_SITE',
                      payload: result
                    });
                  }
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function loadSite() {
        return _ref8.apply(this, arguments);
      };
    }();

    loadSite();
  }, [updatesTimer, previewID]);
  (0, _react.useEffect)(function () {
    var refreshToken = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _actions.authActions.refreshToken({}, config);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function refreshToken() {
        return _ref9.apply(this, arguments);
      };
    }();

    if (refreshTimer > 0) {
      refreshToken();
    }
  }, [refreshTimer]);

  if (!sites[siteID]) {
    return /*#__PURE__*/_react.default.createElement(_Loader.default, null);
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_theme.CmsStyles, null), /*#__PURE__*/_react.default.createElement(_router.Router, null, /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: "".concat(_routes.ROUTE_APP),
    component: _Home.default
  }), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_PROFILE),
    component: _Profile.default
  }), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_SITE, "/:siteID"),
    component: _Dashboard.default
  }), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_SITE, "/:siteID").concat(_routes.ROUTE_MEDIA),
    component: _Media.default
  }), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_SITE, "/:siteID").concat(_routes.ROUTE_POST_TYPE, "/:postTypeID"),
    component: _PostType.default
  }), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_SITE, "/:siteID").concat(_routes.ROUTE_TAXONOMY, "/:taxonomyID"),
    component: _Taxonomy.default
  }), (authUser === null || authUser === void 0 ? void 0 : (_authUser$capabilitie = authUser.capabilities) === null || _authUser$capabilitie === void 0 ? void 0 : _authUser$capabilitie.manage_options) && /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_SITE, "/:siteID").concat(_routes.ROUTE_SETTINGS_GENERAL),
    component: _GeneralSettings.default
  }), (authUser === null || authUser === void 0 ? void 0 : (_authUser$capabilitie2 = authUser.capabilities) === null || _authUser$capabilitie2 === void 0 ? void 0 : _authUser$capabilitie2.list_users) && /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: "".concat(_routes.ROUTE_APP).concat(_routes.ROUTE_SITE, "/:siteID").concat(_routes.ROUTE_USERS),
    component: _Users.default
  }), /*#__PURE__*/_react.default.createElement(_PrivateRoute.default, {
    path: '*',
    component: _PostEditor.default,
    defaultComponent: defaultComponent
  })), dialog.open && /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    transitionName: "none",
    maskTransitionName: "none",
    title: dialog.title,
    visible: true,
    onCancel: function onCancel() {
      return dispatch({
        type: 'CLOSE_DIALOG'
      });
    },
    children: dialog.component,
    width: dialog.width,
    footer: null
  }));
};

var _default = Master;
exports.default = _default;